module.exports = __webpack_public_path__ + "img/XLM.316d17cc.png";